// Shared styles for Jobs screens
import { StyleSheet } from 'react-native';
import { webColors, webBorderRadius, webShadows } from '../../../constants/webStyles';

export const sharedStyles = StyleSheet.create({
  pageHeaderContainer: {
    marginBottom: 0,
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: 1000,
    paddingHorizontal: 24,
    paddingTop: 18,
    zIndex: 9999,
  },
  // Page Header
  pageHeader: {
    marginBottom: 24,
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    paddingHorizontal: 24,
  },
  pageTitle: {
    fontSize: 28,
    fontWeight: '700',
    color: webColors.textPrimary,
    marginBottom: 8,
  },
  pageSubtitle: {
    textAlign: 'center',
    fontSize: 16,
    color: webColors.textMuted,
    lineHeight: 24,
  },

  // Search Section
  searchSection: {
    marginBottom: 24,
    position: 'relative',
    zIndex: 100,
  },
  searchRow: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: webColors.cardBackground,
    borderWidth: 2,
    borderColor: webColors.border,
    borderRadius: 50,
    paddingVertical: 6,
    paddingHorizontal: 6,
    paddingLeft: 24,
    marginBottom: 16,
    gap: 0,
  },
  searchSectionJob: {
    flex: 1.5,
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 10,
    paddingRight: 20,
    marginRight: 20,
    borderRightWidth: 1,
    borderRightColor: webColors.border,
  },
  searchSectionLocation: {
    flex: 0.8,
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 10,
  },
  searchIcon: {
    marginRight: 12,
  },
  searchInput: {
    flex: 1,
    paddingVertical: 4,
    fontSize: 15,
    color: webColors.textPrimary,
    outlineStyle: 'none',
    backgroundColor: 'transparent',
    borderWidth: 0,
  },
  clearBtn: {
    padding: 8,
  },

  // Filter Pills Row
  filterPillsRow: {
    flexDirection: 'row',
    justifyContent: 'center',
    gap: 12,
    flexWrap: 'wrap',
  },
  filterDropdownWrapper: {
    position: 'relative',
  },
  filterPill: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    paddingVertical: 10,
    paddingHorizontal: 16,
    backgroundColor: webColors.cardBackground,
    borderWidth: 1,
    borderColor: webColors.border,
    borderRadius: webBorderRadius.pill,
    cursor: 'pointer',
  },
  filterPillActive: {
    backgroundColor: webColors.primaryLight,
    borderColor: webColors.primary,
  },
  filterPillOpen: {
    borderColor: webColors.primary,
  },
  filterPillLabel: {
    fontSize: 14,
    fontWeight: '500',
    color: webColors.textSecondary,
  },
  filterPillLabelActive: {
    color: webColors.primary,
    fontWeight: '600',
  },
  filterPillText: {
    fontSize: 14,
    fontWeight: '500',
    color: webColors.textSecondary,
  },
  filterPillTextActive: {
    color: webColors.primary,
  },
  filterPillCount: {
    backgroundColor: webColors.primary,
    paddingHorizontal: 8,
    paddingVertical: 2,
    borderRadius: 10,
    minWidth: 20,
    alignItems: 'center',
    justifyContent: 'center',
  },
  filterPillCountText: {
    fontSize: 12,
    fontWeight: '600',
    color: '#ffffff',
  },
  filterPillHighlight: {
    backgroundColor: '#fef3c7',
    borderColor: '#f59e0b',
    borderWidth: 2,
  },

  // Dropdown Styles
  dropdownBackdrop: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 9998,
  },
  filterDropdown: {
    position: 'absolute',
    top: 'calc(100% + 8px)',
    left: 0,
    minWidth: 240,
    backgroundColor: webColors.cardBackground,
    borderRadius: webBorderRadius.large,
    borderWidth: 1,
    borderColor: webColors.border,
    ...webShadows.modal,
    zIndex: 9999,
    overflow: 'hidden',
  },
  dropdownHeader: {
    paddingVertical: 16,
    paddingHorizontal: 20,
    borderBottomWidth: 1,
    borderBottomColor: webColors.borderLight,
  },
  dropdownTitle: {
    fontSize: 14,
    fontWeight: '600',
    color: webColors.textPrimary,
  },
  dropdownOptions: {
    paddingVertical: 8,
    maxHeight: 300,
  },
  dropdownOption: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
    paddingVertical: 12,
    paddingHorizontal: 20,
    cursor: 'pointer',
  },
  dropdownOptionSelected: {
    backgroundColor: webColors.backgroundAlt,
  },
  dropdownOptionText: {
    fontSize: 14,
    color: webColors.textPrimary,
    flex: 1,
  },
  dropdownOptionTextSelected: {
    fontWeight: '600',
    color: webColors.primary,
  },
  dropdownRadio: {
    width: 20,
    height: 20,
    borderRadius: 10,
    borderWidth: 2,
    borderColor: webColors.border,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent',
  },
  dropdownRadioSelected: {
    borderColor: webColors.primary,
  },
  dropdownRadioDot: {
    width: 10,
    height: 10,
    borderRadius: 5,
    backgroundColor: webColors.primary,
  },
  dropdownItem: {
    paddingVertical: 12,
    paddingHorizontal: 16,
    cursor: 'pointer',
  },
  dropdownItemActive: {
    backgroundColor: webColors.primaryLight,
  },
  dropdownItemText: {
    fontSize: 14,
    color: webColors.textPrimary,
  },
  dropdownItemTextActive: {
    color: webColors.primary,
    fontWeight: '600',
  },
  dropdownSearch: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderBottomWidth: 1,
    borderBottomColor: webColors.borderLight,
    backgroundColor: webColors.backgroundAlt,
  },
  dropdownSearchInput: {
    flex: 1,
    fontSize: 14,
    color: webColors.textPrimary,
    outlineStyle: 'none',
    paddingVertical: 4,
  },

  // Profession Dropdown
  professionDropdown: {
    minWidth: 340,
    maxHeight: 450,
  },
  professionDropdownOptions: {
    maxHeight: 300,
    paddingVertical: 8,
  },
  professionLoadingContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 12,
    paddingVertical: 24,
  },
  professionLoadingText: {
    fontSize: 14,
    color: webColors.textMuted,
  },
  professionEmptyContainer: {
    alignItems: 'center',
    paddingVertical: 24,
  },
  professionEmptyText: {
    fontSize: 14,
    color: webColors.textMuted,
  },
  professionTypeGroup: {
    marginBottom: 4,
  },
  professionTypeHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    paddingVertical: 12,
    paddingHorizontal: 16,
    cursor: 'pointer',
  },
  professionTypeHeaderExpanded: {
    backgroundColor: webColors.backgroundAlt,
  },
  professionTypeIcon: {
    fontSize: 18,
  },
  professionTypeLabel: {
    flex: 1,
    fontSize: 14,
    fontWeight: '600',
    color: webColors.textPrimary,
  },
  professionTypeLabelExpanded: {
    color: webColors.primary,
  },
  professionTypeCount: {
    paddingHorizontal: 8,
    paddingVertical: 2,
    borderRadius: 10,
    minWidth: 20,
    alignItems: 'center',
  },
  professionTypeCountText: {
    fontSize: 12,
    fontWeight: '600',
  },
  professionItemsList: {
    paddingLeft: 16,
    backgroundColor: webColors.backgroundAlt,
    borderBottomWidth: 1,
    borderBottomColor: webColors.borderLight,
  },
  professionSubtypeGroup: {
    marginBottom: 2,
  },
  professionSubtypeHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    paddingVertical: 10,
    paddingHorizontal: 16,
    paddingLeft: 24,
    cursor: 'pointer',
  },
  professionSubtypeHeaderExpanded: {
    backgroundColor: webColors.backgroundAlt,
  },
  professionSubtypeLabel: {
    flex: 1,
    fontSize: 13,
    fontWeight: '500',
    color: webColors.textSecondary,
  },
  professionSubtypeLabelExpanded: {
    fontWeight: '600',
    color: webColors.primary,
  },
  professionSubtypeCount: {
    paddingHorizontal: 6,
    paddingVertical: 1,
    borderRadius: 8,
    minWidth: 18,
    alignItems: 'center',
  },
  professionSubtypeCountText: {
    fontSize: 11,
    fontWeight: '600',
  },
  professionSubtypeItemsList: {
    paddingLeft: 32,
    backgroundColor: webColors.backgroundAlt,
  },
  professionItem: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    paddingVertical: 10,
    paddingHorizontal: 16,
    cursor: 'pointer',
  },
  professionItemSelected: {
    backgroundColor: webColors.primaryLight,
  },
  professionCheckbox: {
    width: 18,
    height: 18,
    borderRadius: 4,
    borderWidth: 2,
    borderColor: webColors.border,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent',
  },
  professionCheckboxSelected: {
    backgroundColor: webColors.primary,
    borderColor: webColors.primary,
  },
  professionItemText: {
    flex: 1,
    fontSize: 13,
    color: webColors.textPrimary,
  },
  professionItemTextSelected: {
    fontWeight: '600',
    color: webColors.primary,
  },
  professionDropdownFooter: {
    paddingVertical: 12,
    paddingHorizontal: 16,
    borderTopWidth: 1,
    borderTopColor: webColors.borderLight,
    backgroundColor: webColors.backgroundAlt,
  },
  professionClearBtn: {
    alignItems: 'center',
    paddingVertical: 8,
  },
  professionClearBtnText: {
    fontSize: 13,
    fontWeight: '600',
    color: webColors.primary,
  },

  // Date Filter Dropdown Styles
  dateFilterDropdown: {
    width: 370,
    overflow: 'hidden',
  },
  dateFilterTabs: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: webColors.border,
  },
  dateFilterTab: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6,
    paddingVertical: 14,
    paddingHorizontal: 12,
    position: 'relative',
  },
  dateFilterTabActive: {
    borderBottomWidth: 2,
    borderBottomColor: webColors.primary,
    marginBottom: -1,
  },
  dateFilterTabText: {
    fontSize: 13,
    fontWeight: '500',
    color: webColors.textMuted,
  },
  dateFilterTabTextActive: {
    color: webColors.primary,
  },
  dateFilterTabBadge: {
    paddingHorizontal: 6,
    paddingVertical: 2,
    backgroundColor: webColors.border,
    borderRadius: 4,
  },
  dateFilterTabBadgeActive: {
    backgroundColor: webColors.primaryLight,
  },
  dateFilterTabBadgeText: {
    fontSize: 9,
    fontWeight: '700',
    color: webColors.textMuted,
    textTransform: 'uppercase',
    letterSpacing: 0.3,
  },
  dateFilterTabBadgeTextActive: {
    color: webColors.primary,
  },
  dateFilterTabContent: {},
  dateFilterOptions: {
    padding: 8,
  },
  dateFilterOption: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
    paddingVertical: 11,
    paddingHorizontal: 12,
    borderRadius: 10,
  },
  dateFilterOptionSelected: {
    backgroundColor: webColors.primaryLight,
  },
  dateFilterRadio: {
    width: 18,
    height: 18,
    borderWidth: 2,
    borderColor: webColors.border,
    borderRadius: 9,
  },
  dateFilterRadioSelected: {
    borderColor: webColors.primary,
    borderWidth: 5,
  },
  dateFilterOptionText: {
    fontSize: 14,
    color: webColors.textPrimary,
  },
  shiftDateContent: {
    padding: 16,
  },
  shiftDateNote: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 8,
    paddingVertical: 10,
    paddingHorizontal: 12,
    backgroundColor: '#fffbeb',
    borderWidth: 1,
    borderColor: '#fef3c7',
    borderRadius: 10,
    marginBottom: 16,
  },
  shiftDateNoteText: {
    flex: 1,
    fontSize: 12,
    color: '#92400e',
    lineHeight: 18,
  },
  shiftDateRow: {
    flexDirection: 'row',
    gap: 12,
    marginBottom: 16,
  },
  shiftDateInputGroup: {
    flex: 1,
  },
  shiftDateLabel: {
    fontSize: 11,
    fontWeight: '600',
    color: webColors.textMuted,
    textTransform: 'uppercase',
    letterSpacing: 0.3,
    marginBottom: 6,
  },
  shiftDateInput: {
    width: '100%',
    paddingVertical: 10,
    paddingHorizontal: 12,
    borderWidth: 1,
    borderColor: webColors.border,
    borderRadius: 10,
    fontSize: 13,
    color: webColors.textPrimary,
    backgroundColor: webColors.cardBackground,
    outlineStyle: 'none',
  },
  shiftDateInputActive: {
    borderColor: webColors.primary,
  },
  quickSelectLabel: {
    fontSize: 11,
    fontWeight: '600',
    color: webColors.textMuted,
    textTransform: 'uppercase',
    letterSpacing: 0.3,
    marginBottom: 8,
  },
  quickSelectBtns: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 6,
  },
  quickSelectBtn: {
    paddingVertical: 7,
    paddingHorizontal: 12,
    backgroundColor: webColors.cardBackground,
    borderWidth: 1,
    borderColor: webColors.border,
    borderRadius: 8,
  },
  quickSelectBtnActive: {
    borderColor: webColors.primary,
    backgroundColor: webColors.primaryLight,
  },
  quickSelectBtnText: {
    fontSize: 12,
    fontWeight: '500',
    color: webColors.textMuted,
  },
  quickSelectBtnTextActive: {
    color: webColors.primary,
  },
  dateFilterFooter: {
    flexDirection: 'row',
    gap: 8,
    paddingVertical: 12,
    paddingHorizontal: 12,
    borderTopWidth: 1,
    borderTopColor: webColors.borderLight,
  },
  dateFilterClearBtn: {
    flex: 1,
    paddingVertical: 10,
    backgroundColor: webColors.backgroundAlt,
    borderRadius: 10,
    alignItems: 'center',
  },
  dateFilterClearBtnText: {
    fontSize: 13,
    fontWeight: '500',
    color: webColors.textMuted,
  },
  dateFilterApplyBtn: {
    flex: 1,
    paddingVertical: 10,
    backgroundColor: webColors.primary,
    borderRadius: 10,
    alignItems: 'center',
  },
  dateFilterApplyBtnText: {
    fontSize: 13,
    fontWeight: '600',
    color: '#ffffff',
  },

  // Salary Dropdown Styles
  salaryDropdown: {
    minWidth: 320,
    padding: 0,
  },
  salaryDropdownHeader: {
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderBottomWidth: 1,
    borderBottomColor: webColors.borderLight,
  },
  salaryDropdownTitle: {
    fontSize: 15,
    fontWeight: '600',
    color: webColors.textPrimary,
    marginBottom: 2,
  },
  salaryDropdownSubtitle: {
    fontSize: 13,
    color: webColors.textMuted,
  },
  salaryDropdownContent: {
    padding: 20,
  },
  salaryInputsRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
    paddingHorizontal: 16,
    paddingVertical: 16,
  },
  salaryInputWrapper: {
    flex: 1,
  },
  salaryInputLabel: {
    fontSize: 12,
    fontWeight: '600',
    color: webColors.textSecondary,
    marginBottom: 6,
    textTransform: 'uppercase',
  },
  salaryInputContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: webColors.border,
    borderRadius: webBorderRadius.medium,
    backgroundColor: webColors.backgroundAlt,
    paddingHorizontal: 12,
    paddingVertical: 10,
  },
  salaryInputPrefix: {
    fontSize: 14,
    fontWeight: '600',
    color: webColors.textSecondary,
    marginRight: 6,
  },
  salaryInput: {
    flex: 1,
    fontSize: 14,
    color: webColors.textPrimary,
    outlineStyle: 'none',
    padding: 0,
    minWidth: 60,
  },
  salaryDivider: {
    fontSize: 16,
    color: webColors.textMuted,
    paddingTop: 20,
  },
  salaryInputDivider: {
    fontSize: 16,
    color: webColors.textMuted,
    paddingTop: 20,
  },
  salaryDropdownFooter: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderTopWidth: 1,
    borderTopColor: webColors.borderLight,
    backgroundColor: webColors.backgroundAlt,
  },
  salaryClearBtn: {
    paddingVertical: 8,
    paddingHorizontal: 16,
  },
  salaryClearBtnText: {
    fontSize: 14,
    fontWeight: '500',
    color: webColors.textSecondary,
  },
  salaryApplyBtn: {
    paddingVertical: 8,
    paddingHorizontal: 20,
    backgroundColor: webColors.primary,
    borderRadius: webBorderRadius.medium,
  },
  salaryApplyBtnText: {
    fontSize: 14,
    fontWeight: '600',
    color: '#ffffff',
  },

  // Results Info
  resultsInfo: {
    marginBottom: 16,
  },
  resultsCount: {
    fontSize: 14,
    color: webColors.textMuted,
  },

  // Master-Detail Layout
  masterDetailLayout: {
    flexDirection: 'row',
    gap: 24,
    minHeight: 'calc(100vh - 300px)',
  },
  jobListPanel: {
    width: 480,
    flexShrink: 0,
  },
  jobListScroll: {
    flex: 1,
    maxHeight: 'calc(100vh - 130px)',
    overflow: 'hidden',
  },
  jobCardsList: {
    gap: 16,
  },
  jobDetailPanel: {
    flex: 1,
    backgroundColor: webColors.cardBackground,
    borderWidth: 1,
    borderColor: webColors.border,
    borderRadius: webBorderRadius.large,
    position: 'sticky',
    top: 10,
    maxHeight: 'calc(100vh - 130px)',
    overflow: 'hidden',
  },
  detailScroll: {
    flex: 1,
    padding: 32,
  },

  // Loading/Error/Empty States
  loadingContainer: {
    alignItems: 'center',
    paddingVertical: 60,
  },
  loadingText: {
    marginTop: 16,
    fontSize: 14,
    color: webColors.textMuted,
  },
  errorState: {
    alignItems: 'center',
    paddingVertical: 60,
  },
  errorIcon: {
    marginBottom: 16,
  },
  errorTitle: {
    fontSize: 20,
    fontWeight: '600',
    color: webColors.textPrimary,
    marginBottom: 8,
  },
  errorText: {
    fontSize: 14,
    color: webColors.textMuted,
  },
  emptyState: {
    alignItems: 'center',
    paddingVertical: 60,
  },
  emptyIcon: {
    marginBottom: 16,
  },
  emptyTitle: {
    fontSize: 20,
    fontWeight: '600',
    color: webColors.textPrimary,
    marginBottom: 8,
  },
  emptyText: {
    fontSize: 14,
    color: webColors.textMuted,
    marginBottom: 16,
  },
  clearFiltersBtn: {
    paddingHorizontal: 20,
    paddingVertical: 10,
    backgroundColor: webColors.backgroundAlt,
    borderRadius: webBorderRadius.medium,
  },
  clearFiltersBtnText: {
    fontSize: 14,
    fontWeight: '600',
    color: webColors.textSecondary,
  },
  clearFiltersInline: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    paddingVertical: 10,
    paddingHorizontal: 12,
    cursor: 'pointer',
  },
  clearFiltersInlineText: {
    fontSize: 14,
    color: webColors.textMuted,
  },
  noSelectionState: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 100,
  },
  noSelectionIcon: {
    marginBottom: 16,
  },
  noSelectionText: {
    fontSize: 16,
    color: webColors.textMuted,
  },
  detailLoading: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 100,
  },
  // ==================== MOBILE VARIANTS ====================
  pageTitleMobile: {
    fontSize: 22,
    lineHeight: 28,
  },
  pageSubtitleMobile: {
    fontSize: 14,
    lineHeight: 20,
  },
  searchRowMobile: {
    flexDirection: 'column',
    alignItems: 'stretch',
    borderRadius: 16,
    paddingLeft: 6,
  },
  searchSectionJobMobile: {
    marginRight: 0,
    paddingLeft: 12,
    paddingRight: 12,
    borderRightWidth: 0,
    borderBottomWidth: 1,
    borderBottomColor: webColors.border,
  },
  searchSectionLocationMobile: {
    paddingHorizontal: 12,
  },
  masterDetailLayoutMobile: {
    flexDirection: 'column',
    gap: 0,
    minHeight: 'auto',
  },
  jobListPanelMobile: {
    width: '100%',
  },
  jobDetailPanelMobile: {
    width: '100%',
    position: 'relative',
    top: 0,
    maxHeight: 'none',
  },
  detailScrollMobile: {
    padding: 16,
  },
  filtersButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    paddingVertical: 12,
    paddingHorizontal: 16,
    backgroundColor: webColors.cardBackground,
    borderWidth: 1,
    borderColor: webColors.border,
    borderRadius: webBorderRadius.pill,
    cursor: 'pointer',
  },
  filtersButtonActive: {
    borderColor: webColors.primary,
    backgroundColor: webColors.primaryLight,
  },
  filtersButtonText: {
    fontSize: 14,
    fontWeight: '600',
    color: webColors.textPrimary,
  },
  filterPillsRowMobile: {
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: 12,
    flexWrap: 'nowrap',
  },
  filterPillMobile: {
    justifyContent: 'space-between',
    width: '100%',
  },
  filterDropdownMobile: {
    position: 'relative',
    top: 0,
    left: 0,
    width: '100%',
    minWidth: 0,
    marginTop: 8,
    ...webShadows.card,
  },
  professionDropdownMobile: {
    minWidth: 0,
    width: '100%',
    maxHeight: 320,
  },
  filtersSheetOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 20000,
  },
  filtersSheet: {
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundColor: webColors.cardBackground,
    zIndex: 20001,
    flexDirection: 'column',
  },
  filtersSheetHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 20,
    paddingVertical: 16,
    borderBottomWidth: 1,
    borderBottomColor: webColors.borderLight,
  },
  filtersSheetTitle: {
    fontSize: 18,
    fontWeight: '700',
    color: webColors.textPrimary,
  },
  filtersSheetBody: {
    flex: 1,
    padding: 20,
  },
  filtersSheetFooter: {
    flexDirection: 'row',
    gap: 12,
    padding: 16,
    borderTopWidth: 1,
    borderTopColor: webColors.borderLight,
  },
  filtersSheetApplyBtn: {
    flex: 1,
    backgroundColor: webColors.primary,
    paddingVertical: 14,
    borderRadius: webBorderRadius.medium,
    alignItems: 'center',
    cursor: 'pointer',
  },
  filtersSheetApplyBtnText: {
    fontSize: 15,
    fontWeight: '600',
    color: '#ffffff',
  },
});

// Job Card Styles (Left Panel)
export const jobCardStyles = StyleSheet.create({
  jobCard: {
    backgroundColor: webColors.cardBackground,
    borderWidth: 1,
    borderColor: webColors.border,
    borderRadius: webBorderRadius.medium,
    padding: 20,
    cursor: 'pointer',
  },
  jobCardSelected: {
    background: 'linear-gradient(135deg, #fdf2f8 0%, #fce7f3 100%)',
    backgroundColor: '#fce7f3',
    borderColor: webColors.primary,
  },
  jobCardHeader: {
    marginBottom: 12,
  },
  jobCardTitleRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  jobCardTitle: {
    flex: 1,
    fontSize: 17,
    fontWeight: '600',
    color: webColors.textPrimary,
    marginRight: 12,
  },
  jobCardSubtitlePill: {
    alignSelf: 'flex-start',
    background: 'linear-gradient(135deg, #818cf8 0%, #7c3aed 100%)',
    backgroundColor: '#7c3aed',
    borderRadius: 20,
    paddingHorizontal: 14,
    paddingVertical: 6,
    marginBottom: 8,
  },
  jobCardSubtitleText: {
    fontSize: 13,
    fontWeight: '600',
    color: '#ffffff',
  },
  jobCardTime: {
    fontSize: 13,
    color: webColors.textMuted,
  },
  jobCardCompany: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
    marginBottom: 12,
  },
  jobCardLogo: {
    width: 40,
    height: 40,
    borderRadius: 20,
    alignItems: 'center',
    justifyContent: 'center',
  },
  jobCardLogoText: {
    fontSize: 16,
    fontWeight: '700',
    color: webColors.textPrimary,
  },
  jobCardCompanyInfo: {
    flex: 1,
  },
  jobCardCompanyName: {
    fontSize: 14,
    fontWeight: '500',
    marginBottom: 4,
  },
  jobCardLocationRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
  },
  jobCardLocation: {
    fontSize: 14,
    color: webColors.textMuted,
  },
  jobCardTags: {
    flexDirection: 'row',
    gap: 8,
    flexWrap: 'wrap',
  },
  jobCardTag: {
    paddingHorizontal: 12,
    paddingVertical: 6,
    backgroundColor: '#f3f4f6',
    borderRadius: 6,
  },
  jobCardTagRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
  },
  jobCardTagText: {
    fontSize: 13,
    fontWeight: '500',
    color: '#4b5563',
  },
  jobCardTagSchedule: {
    background: 'linear-gradient(135deg, #fce4ec 0%, #f8bbd9 100%)',
    backgroundColor: '#fce4ec',
  },
  jobCardTagScheduleText: {
    color: '#c2185b',
  },
  jobCardTagDeadline: {
    backgroundColor: '#fef3c7',
  },
  jobCardTagDeadlineText: {
    color: '#92400e',
  },
});

// Job Detail Styles (Right Panel)
export const jobDetailStyles = StyleSheet.create({
  detailContent: {
    position: 'relative',
  },
  detailHeader: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 16,
    marginBottom: 24,
    paddingBottom: 24,
    borderBottomWidth: 1,
    borderBottomColor: webColors.border,
  },
  detailHeaderMobile: {
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: 12,
  },
  detailLogo: {
    width: 56,
    height: 56,
    borderRadius: 28,
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  detailLogoText: {
    fontSize: 20,
    fontWeight: '700',
    color: webColors.textPrimary,
  },
  detailHeaderInfo: {
    flex: 1,
    minWidth: 0,
  },
  detailCompanyName: {
    fontSize: 15,
    fontWeight: '600',
    marginBottom: 8,
  },
  detailJobTitle: {
    fontSize: 22,
    fontWeight: '700',
    color: webColors.textPrimary,
    marginBottom: 12,
  },
  detailSubtitlePill: {
    alignSelf: 'flex-start',
    background: 'linear-gradient(135deg, #818cf8 0%, #7c3aed 100%)',
    backgroundColor: '#7c3aed',
    borderRadius: 20,
    paddingHorizontal: 16,
    paddingVertical: 8,
    marginBottom: 10,
  },
  detailSubtitleText: {
    fontSize: 12,
    fontWeight: '600',
    color: '#ffffff',
  },
  detailMeta: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 16,
    marginBottom: 16,
  },
  detailMetaItemRow: {
    maxWidth: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
  },
  detailMetaItem: {
    flexShrink: 1,
    fontSize: 14,
    color: webColors.textMuted,
  },
  detailActions: {
    flexWrap: 'wrap',
    flexDirection: 'row',
    gap: 12,
    marginBottom: 16,
    zIndex: 9999999,
  },
  applyBtn: {
    paddingHorizontal: 24,
    paddingVertical: 12,
    backgroundColor: webColors.primary,
    borderRadius: webBorderRadius.medium,
    ...webShadows.button,
  },
  applyBtnText: {
    fontSize: 15,
    fontWeight: '600',
    color: '#ffffff',
  },
  saveBtn: {
    paddingHorizontal: 20,
    paddingVertical: 12,
    backgroundColor: webColors.backgroundAlt,
    borderRadius: webBorderRadius.medium,
    borderWidth: 1,
    borderColor: webColors.border,
  },
  saveBtnText: {
    fontSize: 14,
    fontWeight: '600',
    color: webColors.textSecondary,
  },
  detailTags: {
    flexDirection: 'row',
    gap: 8,
    flexWrap: 'wrap',
  },
  detailTag: {
    maxWidth: '100%',
    paddingHorizontal: 12,
    paddingVertical: 6,
    backgroundColor: '#f3f4f6',
    borderRadius: 6,
  },
  detailTagRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
  },
  detailTagText: {
    flexShrink: 1,
    fontSize: 13,
    fontWeight: '500',
    color: '#4b5563',
  },
  detailTagSchedule: {
    background: 'linear-gradient(135deg, #fce4ec 0%, #f8bbd9 100%)',
    backgroundColor: '#fce4ec',
  },
  detailTagScheduleText: {
    color: '#c2185b',
  },

  // Detail Sections
  detailSection: {
    marginTop: 32,
  },
  detailSectionTitle: {
    fontSize: 18,
    fontWeight: '700',
    color: webColors.textPrimary,
    marginBottom: 16,
  },
  detailSectionText: {
    fontSize: 15,
    color: '#4b5563',
    lineHeight: 24,
  },
  earningsHighlight: {
    fontSize: 20,
    fontWeight: '700',
    color: webColors.textPrimary,
    marginBottom: 8,
  },
  earningsTotal: {
    fontSize: 15,
    color: webColors.textSecondary,
    marginBottom: 12,
  },
  salaryText: {
    fontSize: 18,
    fontWeight: '600',
    color: webColors.textPrimary,
  },
  paymentBadge: {
    alignSelf: 'flex-start',
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderWidth: 1,
    borderRadius: 6,
  },
  paymentBadgeText: {
    fontSize: 12,
    fontWeight: '700',
  },
  expertiseGroup: {
    marginBottom: 16,
  },
  expertiseLabel: {
    fontSize: 12,
    fontWeight: '700',
    color: webColors.textSecondary,
    marginBottom: 8,
  },
  listItem: {
    flexDirection: 'row',
    gap: 12,
    marginBottom: 12,
    paddingLeft: 8,
  },
  listBullet: {
    fontSize: 16,
    color: '#5B9FF9',
    fontWeight: '700',
  },
  listText: {
    flex: 1,
    fontSize: 15,
    color: '#4b5563',
    lineHeight: 24,
  },
  dateText: {
    fontSize: 16,
    fontWeight: '600',
    color: webColors.textPrimary,
    marginBottom: 4,
  },
  timeText: {
    fontSize: 14,
    color: webColors.textSecondary,
  },
  facilityInfo: {
    flexDirection: 'row',
    gap: 16,
  },
  facilityLogo: {
    width: 56,
    height: 56,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
  },
  facilityLogoText: {
    fontSize: 20,
    fontWeight: '700',
    color: webColors.textPrimary,
  },
  facilityDetails: {
    flex: 1,
  },
  facilityName: {
    fontSize: 16,
    fontWeight: '600',
    color: webColors.textPrimary,
    marginBottom: 4,
  },
  facilityAddress: {
    fontSize: 14,
    color: webColors.textMuted,
    lineHeight: 20,
  },
  facilityNavButtons: {
    flexWrap: 'wrap',
    flexDirection: 'row',
    gap: 10,
    marginTop: 16,
  },
  facilityNavButton: {
    flexDirection: 'row',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: 'rgba(0,0,0,0.2)',
    borderRadius: 10,
    paddingVertical: 8,
    paddingHorizontal: 12,
    gap: 8,
  },
  facilityNavButtonText: {
    fontSize: 13,
    fontWeight: '600',
    color: webColors.textPrimary,
  },

  // Share Button Styles
  shareButtonWrapper: {
    position: 'relative',
  },
  shareButtonContent: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  shareMenuInline: {
    position: 'absolute',
    top: 'calc(100% + 12px)',
    left: 0,
    backgroundColor: webColors.cardBackground,
    borderRadius: 16,
    ...webShadows.modal,
    minWidth: 280,
    zIndex: 9999,
    overflow: 'visible',
  },
  shareMenuMobile: {
    position: 'fixed',
    top: '20%',
    left: 16,
    right: 16,
    minWidth: 0,
    maxHeight: '70vh',
    overflow: 'auto',
  },
  shareMenuArrowInline: {
    position: 'absolute',
    top: -8,
    left: 24,
    width: 0,
    height: 0,
    borderLeftWidth: 10,
    borderLeftColor: 'transparent',
    borderRightWidth: 10,
    borderRightColor: 'transparent',
    borderBottomWidth: 10,
    borderBottomColor: webColors.cardBackground,
  },
  shareBackdrop: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 9998,
  },
  shareMenu: {
    position: 'absolute',
    top: 'calc(100% + 12px)',
    right: 0,
    backgroundColor: webColors.cardBackground,
    borderRadius: 16,
    ...webShadows.modal,
    minWidth: 280,
    zIndex: 9999,
    overflow: 'visible',
  },
  shareMenuArrow: {
    position: 'absolute',
    top: -8,
    right: 24,
    width: 0,
    height: 0,
    borderLeftWidth: 10,
    borderLeftColor: 'transparent',
    borderRightWidth: 10,
    borderRightColor: 'transparent',
    borderBottomWidth: 10,
    borderBottomColor: webColors.cardBackground,
  },
  shareMenuHeader: {
    paddingVertical: 14,
    paddingHorizontal: 18,
    borderBottomWidth: 1,
    borderBottomColor: webColors.borderLight,
    alignItems: 'center',
  },
  shareMenuTitle: {
    fontSize: 13,
    fontWeight: '600',
    color: webColors.textMuted,
  },
  shareOptionsRow: {
    flexDirection: 'row',
    gap: 6,
    paddingHorizontal: 16,
    paddingVertical: 8,
  },
  shareOption: {
    flex: 1,
    alignItems: 'center',
    gap: 8,
    paddingVertical: 12,
    paddingHorizontal: 6,
    borderRadius: 12,
    cursor: 'pointer',
  },
  shareOptionIcon: {
    width: 48,
    height: 48,
    borderRadius: 24,
    alignItems: 'center',
    justifyContent: 'center',
  },
  shareIconCopy: {
    backgroundColor: '#f0f0f0',
  },
  shareIconWhatsApp: {
    backgroundColor: '#25D366',
  },
  shareIconTelegram: {
    backgroundColor: '#0088cc',
  },
  shareIconEmail: {
    backgroundColor: '#e91e8c',
  },
  shareIconFacebook: {
    backgroundColor: '#1877F2',
  },
  shareIconLinkedIn: {
    backgroundColor: '#0A66C2',
  },
  shareIconViber: {
    backgroundColor: '#7360F2',
  },
  shareOptionText: {
    fontSize: 11,
    fontWeight: '500',
    color: webColors.textMuted,
  },
  toast: {
    position: 'fixed',
    bottom: 30,
    left: '50%',
    transform: [{ translateX: '-50%' }],
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    paddingVertical: 12,
    paddingHorizontal: 24,
    backgroundColor: '#333',
    borderRadius: 25,
    zIndex: 10000,
  },
  toastText: {
    fontSize: 14,
    fontWeight: '500',
    color: '#ffffff',
  },
});

// Modal Styles
export const modalStyles = StyleSheet.create({
  successContent: {
    padding: 40,
    alignItems: 'center',
  },
  successIcon: {
    width: 64,
    height: 64,
    borderRadius: 32,
    backgroundColor: '#dcfce7',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 20,
  },
  successTitle: {
    fontSize: 20,
    fontWeight: '700',
    color: webColors.textPrimary,
    marginBottom: 8,
  },
  successText: {
    fontSize: 14,
    color: webColors.textMuted,
    textAlign: 'center',
    marginBottom: 24,
  },
  successBtn: {
    paddingHorizontal: 24,
    paddingVertical: 12,
    backgroundColor: webColors.primary,
    borderRadius: webBorderRadius.medium,
  },
  successBtnText: {
    fontSize: 14,
    fontWeight: '600',
    color: '#ffffff',
  },
  applyModalContent: {
    padding: 24,
  },
  applyModalText: {
    fontSize: 16,
    color: webColors.textPrimary,
    marginBottom: 16,
    lineHeight: 24,
  },
  applyModalDetails: {
    padding: 16,
    backgroundColor: webColors.backgroundAlt,
    borderRadius: webBorderRadius.medium,
    marginBottom: 24,
    gap: 8,
  },
  applyModalDetailRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
  },
  applyModalDetail: {
    fontSize: 14,
    color: webColors.textSecondary,
  },
  applyModalActions: {
    flexDirection: 'row',
    gap: 12,
    justifyContent: 'flex-end',
  },
  cancelModalBtn: {
    paddingHorizontal: 20,
    paddingVertical: 12,
    backgroundColor: webColors.backgroundAlt,
    borderRadius: webBorderRadius.medium,
  },
  cancelModalBtnText: {
    fontSize: 14,
    fontWeight: '600',
    color: webColors.textSecondary,
  },
  confirmModalBtn: {
    paddingHorizontal: 24,
    paddingVertical: 12,
    backgroundColor: webColors.primary,
    borderRadius: webBorderRadius.medium,
    ...webShadows.button,
  },
  confirmModalBtnDisabled: {
    opacity: 0.6,
  },
  confirmModalBtnText: {
    fontSize: 14,
    fontWeight: '600',
    color: '#ffffff',
  },
});

// View Tabs Styles (for authenticated Jobs screen)
export const viewTabsStyles = StyleSheet.create({
  viewTabs: {
    maxWidth: 1000,
    marginLeft: 'auto',
    marginRight: 'auto',
    flexDirection: 'row',
    gap: 12,
    marginBottom: 24,
  },
  viewTab: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    paddingHorizontal: 20,
    paddingVertical: 10,
    borderRadius: webBorderRadius.pill,
    backgroundColor: webColors.cardBackground,
    borderWidth: 1,
    borderColor: webColors.border,
    cursor: 'pointer',
  },
  viewTabActive: {
    backgroundColor: webColors.primary,
    borderColor: webColors.primary,
  },
  viewTabText: {
    fontSize: 14,
    fontWeight: '500',
    color: webColors.textMuted,
  },
  viewTabTextActive: {
    color: '#ffffff',
  },
  viewTabBadge: {
    minWidth: 20,
    height: 20,
    backgroundColor: webColors.backgroundAlt,
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 6,
  },
  viewTabBadgeActive: {
    backgroundColor: 'rgba(255,255,255,0.3)',
  },
  viewTabBadgeText: {
    fontSize: 11,
    fontWeight: '700',
    color: webColors.textPrimary,
  },
  viewTabBadgeTextActive: {
    color: '#ffffff',
  },
});
